
import GwContentTemplate from '~/patterns/templates/content';
import FlexibleSection from '~/patterns/organisms/_flexible-section/flexible-section';
import getKnowledgePage from '~/graphql/queries/getKnowledgePage.graphql';
import seo from '~/mixins/seo';
import GwPageContainer from '~/patterns/molecules/page-container/page-container';
import GwPageTitle from '~/patterns/molecules/page-title/page-title';
import GwPageIntro from '~/patterns/molecules/page-intro/page-intro.vue';
import GwPageMeta from '~/patterns/molecules/page-meta/page-meta';
import GwAuthor from '~/patterns/organisms/author/author.vue';
import GwError from '~/patterns/molecules/error';

export default {
    components: {
        GwContentTemplate,
        GwPageContainer,
        GwPageTitle,
        GwPageIntro,
        GwPageMeta,
        GwAuthor,
        GwError,
        FlexibleSection,
    },
    mixins: [seo],
    data() {
        return {
            entry: null,
            notFound: false,
        };
    },
    async fetch() {
        const site = this.$config.appMultisiteHandle,
            uri = this.$route.path.replace(/^\/|\/$/, ''),
            { data } = await this.$gql.executeQuery(
                getKnowledgePage,
                { site, uri }
            );
        if (data && data.entry) {
            this.entry = data.entry;
        } else {
            this.notFound = true;
            if (process.server) {
                this.$nuxt.context.res.statusCode = 404;
            }
        }
    },
    computed: {
        category() {
            if (!this.entry || !this.entry.knowledgeCategories.length) {
                return 'Blogs';
            }

            return this.entry.knowledgeCategories[0].title;
        }
    },
    methods: {
        formatDate(date) {
            return this.$d(new Date(date), 'dateShort');
        }
    },
    nuxtI18n: {
        paths: {
            en: '/knowledge/:category/:slug',
            in: '/knowledge/:category/:slug',
            nl: '/knowledge/:category/:slug',
            fr: '/articles/:category/:slug',
            de: '/knowledge/:category/:slug',
            'en-Highberg': '/knowledge/:category/:slug',
            'nl-Highberg': '/knowledge/:category/:slug',
            'de-Highberg': '/knowledge/:category/:slug',
        }
    }
};
